import { lazy } from 'react';

export const Network = lazy(() =>
  import(/* webpackChunkName: "network", webpackPrefetch: true */ './index'),
);
